import { useTranslation } from 'react-i18next';
import './ReleaseCalendar.css';

/**
 * Button component for opening the release calendar modal
 * This stays in the table header
 */
function ReleaseCalendarButton({ slot, onClick }) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onClick}
      className="release-calendar-button"
      title={t('releaseCalendar.releaseSlot', { slot: slot.label })}
    >
      🗓️
    </button>
  );
}

export default ReleaseCalendarButton;
